import { BACKEND_URL } from '../config';
import { AUTH_TOKEN_STORAGE_KEY } from './client';

export interface CheckoutSessionParams {
  lookup_key: string;
  success_url: string;
  cancel_url: string;
}

export interface CheckoutSessionResponse {
  url: string;
  session_id?: string;
}

export interface PortalSessionParams {
  return_url: string;
  session_id?: string;
}

export interface PortalSessionResponse {
  url: string;
}

/**
 * Create a Stripe checkout session for upgrading to premium
 */
export async function createCheckoutSession(
  params: CheckoutSessionParams
): Promise<CheckoutSessionResponse> {
  const token = localStorage.getItem(AUTH_TOKEN_STORAGE_KEY);
  
  if (!token) {
    throw new Error('Authentication required to create checkout session');
  }

  const response = await fetch(`${BACKEND_URL}/v1/stripe/create-checkout-session`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': token.startsWith('Bearer ') ? token : `Bearer ${token}`
    },
    body: JSON.stringify(params)
  });

  if (!response.ok) {
    const errorData = await response.json().catch(() => ({}));
    throw new Error(errorData.error || errorData.message || 'Failed to create checkout session');
  }

  return response.json();
}

/**
 * Create a Stripe billing portal session for managing subscription
 */
export async function createPortalSession(
  params: PortalSessionParams
): Promise<PortalSessionResponse> {
  const token = localStorage.getItem(AUTH_TOKEN_STORAGE_KEY);
  
  if (!token) {
    throw new Error('Authentication required to create portal session');
  }

  const response = await fetch(`${BACKEND_URL}/v1/stripe/create-portal-session`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': token.startsWith('Bearer ') ? token : `Bearer ${token}`
    },
    body: JSON.stringify(params)
  });

  if (!response.ok) {
    const errorData = await response.json().catch(() => ({}));
    throw new Error(errorData.error || errorData.message || 'Failed to create portal session');
  }

  return response.json();
}
